import { BehaviorSubject } from 'rxjs';

const chargesBreakdown = new BehaviorSubject({});
const discountsBreakdown = new BehaviorSubject({});
const paymentBreakdown = new BehaviorSubject({});

const chargesBreakdownStore = {
  update: value => {
    chargesBreakdown.next(value);
  },
  subscribe: setState => chargesBreakdown.subscribe(setState),
  getValue: () => chargesBreakdown.value,
};

const discountsBreakdownStore = {
  update: value => {
    discountsBreakdown.next(value);
  },
  subscribe: setState => discountsBreakdown.subscribe(setState),
  getValue: () => discountsBreakdown.value,
};

const paymentBreakdownStore = {
  update: value => {
    paymentBreakdown.next(value);
  },
  subscribe: setState => paymentBreakdown.subscribe(setState),
  getValue: () => paymentBreakdown.value,
};

export { chargesBreakdownStore, discountsBreakdownStore, paymentBreakdownStore };
